import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/common/crossSiteLabel.scss';

const CrossSiteLabel = ({ store }) => {
  const { testId } = useMartyContext();
  if (store) {
    return (
      <p
        className={cn(
          css.crossSiteLabel,
          { [css.zenCrossSiteLabel]: store.includes('zen') },
          { [css.vrsnlCrossSiteLabel]: store.includes('vrsnl') })}
        data-test-id={testId('crossSiteLabel')}
        aria-label={`Available on ${store}.com`}>
        {`${store}.com`}
      </p>
    );
  }
  return null;
};

export default CrossSiteLabel;
